import { Container, Sprite, Texture } from 'pixi.js';
import { TextMetrics } from 'pixi.js';
import { RectangleElement } from '../primitive/rectangle-element';
import { PathElement } from '../primitive/path-element';
import { TextElement } from '../primitive/text-element';
import { TextLetter } from './text-letter';
import { IncrementController } from '../../../animation/frame/increment/controller/increment.controller';
import { TextAnimationConfig } from '../../../../elements/resource/types/shape.type';
import { TextLine } from './text-line';
import { DropShadowElement } from '../primitive/drop-shadow-element';
import gsap from 'gsap';
import { TextAnimationStep } from '../../../animation/text-animation.service';
export interface TextwordDescriptor {
  value: string;
  width: number;
  startCharacterIndex: number;
  letterWidths: number[];
}
export class TextWord {
  dropShadowElement: DropShadowElement;
  rect: RectangleElement;
  selected: Record<number, boolean> = {};
  get index() {
    return this.config.index;
  }
  get containerX() {
    return this.xOffset;
  }
  get containerY() {
    return this.config.lineYOffset + this.textShape.lineHeightOffset;
  }
  get lineIndex() {
    return this.parent.index;
  }
  get text() {
    return this.descriptor.text;
  }
  get textShpapeContainer() {
    return this.textShape.container;
  }

  get service() {
    return this.textShape.service;
  }

  get textShape() {
    return this.parent.textShape;
  }

  get length() {
    return this.word.length;
  }
  get firstLetter() {
    return this.letters[0];
  }

  get lastLetter() {
    return this.letters[this.letters.length - 1];
  }

  get cs() {
    return this.textShape.cs;
  }
  metric: TextMetrics;
  cursor: PathElement;

  get word() {
    return this.descriptor.text;
  }

  get xOffset() {
    return this.config.xOffset;
  }
  get end() {
    return this.config.xOffset + this.descriptor.width;
  }

  get prev() {
    return this.line.getPrevWord(this);
  }
  get nextWord() {
    return this.line.getNextWord(this);
  }

  get prevLine() {
    return this.line.prev;
  }

  get nextLine() {
    return this.line.next;
  }

  get leftOffset() {
    return this.config.leftOffset || 0;
  }

  get startCharacterIndex() {
    return this.config.startCharacterIndex;
  }

  get rightOffset() {
    return this.config.rightOffset || 0;
  }

  get line() {
    return this.parent;
  }

  get rectHeight() {
    return Math.min(this.textShape.baseLineHeight, this.metric.lineHeight);
  }

  get amILast() {
    return this.config.lineWordIndex == this.line.words.length - 1;
  }

  get cursorIsLastPosition() {
    return this.selectedIndex == this.word.length;
  }

  get lastCursorPositionInLine() {
    return this.line.wrapped && this.amILast && this.cursorIsLastPosition;
  }

  get amISpace() {
    return this.word == ' ';
  }
  get width() {
    return this.config.width;
  }

  get doInitElement() {
    return this.textShape.elementLevel == 'word';
  }

  leftRect: RectangleElement;
  rightRect: RectangleElement;
  textElement: TextElement;
  letters: TextLetter[] = [];
  doubleClickTookPlace = false;
  wholeTextSelectionBlock250ms = false;
  yOffset: number;
  charWidths: number[] = [];
  container: Container;
  globalIndex: number;
  constructor(
    public readonly parent: TextLine,
    private readonly descriptor: { text: string; width: number },
    private readonly config: {
      // x position of the word
      index: number;
      xOffset?: number;
      lineYOffset?: number;
      wordYOffset?: number;
      rightOffset?: number;
      leftOffset?: number;
      lineHeight: number;
      lineWordIndex: number;
      startCharacterIndex: number;
      width: number;
      // style: Text// ;
    },
  ) {
    // console.log('word', this.word, 'index', this.wordIndex); // -- //
    // this.metric = TextMetrics.measureText(this.word, this.style);
    // this.charWidths = Array.from(this.descriptor.value).map(
    //   char => TextMetrics.measureText(char, this.style).maxLineWidth,
    // );

    this.container = new Container();

    // -- // -- // -- // -- // -- //
    // if (config.index == 0 && this.text == 'Breaking' && false) {
    //   // console.log('create-drop-shadow', config.width);
    //   this.dropShadowElement = new DropShadowElement(
    //     this.textShape.cs,
    //     this.container,
    //     {
    //       // x: 2 * config.width,
    //       // y: config.lineHeight / 2,
    //       // position: {
    //       //   x: config.width,
    //       //   y: config.lineHeight / 2,
    //       // },
    //       width: config.width,
    //       height: this.textShape.baseLineHeight,
    //       radius: 8,
    //       color: '#ffffff',
    //       blur: 20,
    //       offset: { x: 0, y: 0 },
    //       alpha: 0.3,
    //       padding: 12,
    //       //ry: 20,
    //       // with zero it looks awsome
    //     },
    //   );
    // }

    // -- // -- // -- // -- // -- //
    if (this.doInitElement) {
      // console.log('--------- doInitElement -------', this.text);

      this.container.alpha = this.textShape.textConfig?.opacity || 1;
      this.textElement = new TextElement(this.textShape, this.container, {
        ...(this.textShape.elementStyle as any),
        text: this.descriptor.text,
        x: 0,
        y: 0,
        dropShadowBlur: 6,
        dropShadowColor: '#bababa',
        dropShadowAlpha: 0.4,
        dropShadowDistance: 4,
        // dropShadow: true,
      });
    }
    // const dropShadow = new DropShadowFilter({
    //   //rotation: 45, // angle in degrees
    //   distance: 30,
    //   blur: 30,
    //   alpha: 0.7,
    //   color: 0x000000,
    // });
    // this.textElement.element.filters = [dropShadow]; // -- //

    // const blur = new BlurFilter(0, 3);
    // this.textElement.element.filters = [blur];
    // }

    this.container.setTransform(
      this.xOffset,
      0,
      // this.config.lineYOffset,
      // this.config.lineYOffset + this.textShape.lineHeightOffset,
    );

    this.parent.container.addChild(this.container);

    // -- // -- // -- // -- //
    // const fullLineHeight =
    //   this.textShape.lineHeight * this.textShape.baseLineHeight;
    // -- // -- //

    // let x = this.leftOffset;
    let x = 0;
    this.letters = Array.from(this.word).map((char, i) => {
      const letter = new TextLetter(this, {
        char: char as string,
        x,
        y: 0,
        height: this.line.cursorHeight,
        index: i,
        firstInLine: this.index == 0 && i == 0,
      });
      x += this.textShape.characterWidthMap[char as string];
      return letter;
    });
    // console.log('letters.length', this.letters.length); //

    this.rect?.hide();

    if (this.leftOffset) {
      this.leftRect = new RectangleElement(
        this.textShape,
        this.textShape.container,
        {
          position: {
            x: this.xOffset - this.leftOffset,
            y: this.config.lineYOffset,
          },
          width: this.leftOffset,
          height: this.line.cursorHeight,
          fill: '#000000',
          opacity: 0.001,
        },
      );

      // if (this.textShape._isRoot) {
      this.leftRect.click(() => {
        if (!this.textShape.selected) {
          return;
        }
        this.showCursorByIndex(0);
      });

      this.addDragHandler(this.leftRect);
      // }
    }

    if (this.rightOffset) {
      this.rightRect = new RectangleElement(
        this.textShape,
        this.textShape.container,
        {
          position: {
            x: this.end,
            y: this.config.lineYOffset,
          },
          width: this.rightOffset,
          height: this.line.cursorHeight,
          fill: '#000000',
          opacity: 0.001,
        },
      );

      // if (this.textShape._isRoot) {
      this.rightRect.click(() => {
        if (!this.textShape.selected) {
          return;
        }
        this.showCursorByIndex(this.letters.length);
      });
      this.addDragHandler(this.rightRect);
      // }
    }
  }
  gradientTexture: Texture;
  gradientSprite: Sprite;
  _addColorGradient(config: {
    baseColor: string;
    targetColor: string;
    textWidth: number;
    gradientWidth: number;
    letterWidth: number;
  }): Sprite {
    // -- // -- //

    const { baseColor, targetColor, textWidth, gradientWidth, letterWidth } =
      config;

    // -- // -- //

    const width = 2 * textWidth + gradientWidth;
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = this.textShape.baseHeight;
    const ctx = canvas.getContext('2d')!;
    // -- //
    const [c1, c2] = [baseColor, targetColor];
    const gradient = ctx.createLinearGradient(0, 0, width, 0);

    const s1 = textWidth;
    const s2 = textWidth + letterWidth;
    const s3 = textWidth + gradientWidth - letterWidth;
    const s4 = textWidth + gradientWidth;
    // const s5 = textWidth + gradientWidth + textWidth;

    gradient.addColorStop(0, c1);
    gradient.addColorStop(s1 / width, c1);
    gradient.addColorStop(s2 / width, c2);
    gradient.addColorStop(s3 / width, c2);
    gradient.addColorStop(s4 / width, c1);
    gradient.addColorStop(1, c1);
    // -- // -- // -- //

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, this.textShape.baseHeight);

    const texture = Texture.from(canvas);
    this.gradientSprite = new Sprite(texture);
    // gradientSprite.anchor.set(0.5);
    // this.gradientSprite.position.copyFrom(pixiText.position);
    this.gradientSprite.x = -(textWidth + gradientWidth);

    return this.gradientSprite;
  }

  setSpriteMask() {
    this.setMask(this.gradientSprite);
  }

  setMask(gradientSprite: Sprite) {
    if (this.textShape.elementLevel == 'word') {
      this.container.addChild(this.gradientSprite);
      gradientSprite.mask = this.textElement.element;
      this.textElement.element.style.fill = 0xffffff; // or [0xffffff];
      this.textElement.element.alpha = 1;
      this.textElement.element.visible = true;
    } else {
      this.letters.map(letter => {
        gradientSprite.mask = letter.element.element;
        letter.element.element.style.fill = 0xffffff; // or [0xffffff];
        letter.element.element.alpha = 1;
        letter.element.element.visible = true;
      });
    }
  }
  addColorGradient(colors: string[], width) {
    // -- // -- //
    // const pixiText = this.textElement.element;

    this.gradientTexture = this.createGradientTexture(
      2 * width,
      this.textShape.baseLineHeight,
      colors,
    );
    // -- // -- // -- //
    this.gradientSprite = new Sprite(this.gradientTexture);
    // gradientSprite.anchor.set(0.5);
    // this.gradientSprite.position.copyFrom(pixiText.position);
    this.gradientSprite.x = -width;
    this.container.addChild(this.gradientSprite);

    if (this.textShape.elementLevel == 'word') {
      this.gradientSprite.mask = this.textElement.element;
      this.textElement.element.style.fill = 0xffffff; // or [0xffffff];
      this.textElement.element.alpha = 1;
      this.textElement.element.visible = true;
    } else {
      this.letters.map(letter => {
        letter.element.element.mask = this.gradientSprite;
        letter.element.element.style.fill = 0xffffff; // or [0xffffff];
        letter.element.element.alpha = 1;
        letter.element.element.visible = true;
      });
    }

    return this.gradientSprite;

    // pixiText.style.fill = 0xffffff; // or [0xffffff];
    // pixiText.alpha = 1;
    // pixiText.visible = true;
  }

  gsapAnimate(step: TextAnimationStep) {
    // -- // -- // -- //
    const { type: baseType, duration, ease, word } = step;

    const { type } = word;
    switch (type) {
      case 'blur':
        // return this.moveColorGradient(duration); //
        break;
    }
  }

  moveColorGradient(duration: number) {
    return gsap.to(this.gradientSprite, {
      x: 0,
      duration,
      ease: 'power1.inOut',
    });
  }

  createGradientTexture(width: number, height: number, colors: string[]) {
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const ctx = canvas.getContext('2d')!;
    // -- //
    const [c1, c2] = colors;
    const gradient = ctx.createLinearGradient(0, 0, width, 0);
    gradient.addColorStop(0, c1);
    gradient.addColorStop(0.25, c2);
    gradient.addColorStop(0.5, c2);
    gradient.addColorStop(0.75, c2);
    gradient.addColorStop(1, c1);
    // -- // -- //

    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, width, height);

    return Texture.from(canvas);
  }

  alignCenter() {
    const lineWidth = this.line.width;
    const { width } = this;
    this.container.x = (lineWidth - width) / 2;
  }

  findLeterByX(x: number) {
    // if () //
    // return this.letters.find(letter => letter._isInMyRegion(x));
  }

  aboveLetter(letter: TextLetter) {
    return this.prev?.lastLetter;
  }

  belowLetter(letter: TextLetter) {
    return this.nextWord?.firstLetter;
  }

  nextLetter(letter: TextLetter) {
    if (letter.index == this.letters.length - 1) {
      return this.nextWord?.firstLetter;
    }
    return this.letters[letter.index + 1];
  }

  prevLetter(letter: TextLetter) {
    if (letter.index == 0) {
      return this.prev?.lastLetter;
    }
    return this.letters[letter.index - 1];
  }

  addDragHandler(rect: RectangleElement) {
    rect?.drag(
      (dx, dy) => {
        this.service.drag(dx, dy);
      },
      () =>
        this.service.startDrag(
          // this.parent.getType() == 'root-shape' ? null : this.parent,
          this.textShape,
        ),
      () => {
        this.service.endDrag();
      },
    );
  }

  animationState: {
    start: number;
    end: number;
    division: number;
    current: number;
    state: 'idle' | 'in-progress' | 'finished';
    config: TextAnimationConfig;
    // -- // -- // -- // -- //
  };

  floatIncrementController: IncrementController;
  opacityIncrementController: IncrementController;
  startAnimation(
    { start, end }: { start: number; end: number },
    config: TextAnimationConfig,
  ) {
    const division = end - start;
    this.animationState = {
      start,
      end,
      division,
      current: 0,
      state: 'idle',
      config,
    };

    const { type, scale, float, by } = config;

    this.opacityIncrementController = new IncrementController(0, 1, division);
    this.container.alpha = 0;

    // if (type == 'mask') {
    this.floatIncrementController = new IncrementController(
      this.textShape.netLineHeight / 2,
      0,
      division,
    );

    // this.container.setTransform()
    // }
    // this._letters.map(letter => {
    //   letter.element.patch({
    //     y: letter.y + this.textShape.netLineHeight / 2,
    //     opacity: 0,
    //   });
    // });
  }

  afterInit() {
    if (this.textShape.selectionStartIndex !== null) {
      // console.log(
      //   'startCharacterIndex',
      //   this.startCharacterIndex,
      //   'selectionStart',
      //   this.textShape.selectionStartIndex,
      // );
      // console.log('word', this.word, this.word.length);

      /* console.log(
        '---selection-start-index---',
        this.textShape.selectionStartIndex,
      ); */

      const index = this.textShape.selectionStartIndex;
      if (
        this.startCharacterIndex <= index &&
        index <= this.startCharacterIndex + this.word.length
      ) {
        this.showCursorByIndex(index - this.startCharacterIndex);
      }
    }
  }
  selectedIndex: number;
  selectionStartIndex: number;

  downWardSelect() {
    if (!this.nextLine) {
      return;
    }
  }

  currentCursorX: number;

  showCursorByIndex(index?: number) {
    if (!this.cs.isShiftPressed) {
      this.textShape.removeSelection();
    }

    this.cs.registerKeyDownHandler(key => this.textShape.keyDownHandler(key));

    if (this.amISpace) {
      // -- //
      if (index == 0 && !this.prev) {
        return;
      }
      // -- //

      if (index == undefined) {
        if (this.prev) {
          return this.prev?.showCursorByIndex();
        }
      } else {
        if (this.nextWord) {
          return this.nextWord?.showCursorByIndex(0);
        }
      }
    }

    // -- // -- // -- // -- // -- //
    if (index == undefined) {
      index = this.letters.length;
    }

    this.selectedIndex = index;

    this.currentCursorX = this.letters[index]
      ? this.letters[index].x
      : this.end;

    // this.textShape.selectionStartWord = this;

    this.textShape._showCursor(
      {
        x: this.xOffset + this.currentCursorX,
        y: this.config.lineYOffset,
        // y: this.lineIndex * this.metric.lineHeight - this.yOffset,
      },
      this,
    );
  }

  getXByIndex(index: number) {
    if (index == 0) {
      return this.xOffset;
    } else if (index < this.letters.length) {
      return this.letters[index].x;
    } else {
      return this.end;
    }
  }

  show() {
    // this.rect?.show();
    this.container.alpha = this.textShape.textConfig.opacity || 1;
    // this.letters.map(letter => letter.show());
  }

  hide() {
    this.rect?.hide();
    this.letters.map(letter => letter.hide());
  }

  cursorRight() {
    console.log('cursor-right', this.selectedIndex);
    if (this.selectedIndex < this.letters.length) {
      console.log('if branch', this.letters.length, this.selectedIndex);
      this.showCursorByIndex(this.selectedIndex + 1);
    } else {
      console.log('else branch', this.letters.length, this.selectedIndex);
      this.nextWord?.showCursorByIndex(0);
    }

    // if (this.next) {
    //   this.next?.showCursorByIndex(0);
    // } else {
    //   this.nextLine?.words[0].showCursorByIndex(0);
    // }
  }

  cursorLeft() {
    // console.log('cursorLeft');
    // console.log('cursorLeft');
    if (0 < this.selectedIndex) {
      this.showCursorByIndex(this.selectedIndex - 1);
    } else {
      this.prev?.showCursorByIndex();
    }

    // if (this.prev) {
    //   this.prev.showCursorByIndex();
    // } else {
    //   this.prevLine?.words[this.prevLine.words.length - 1].showCursorByIndex();
    // }
  }
  findDownWord(strict = false): [TextWord, number] {
    return this.nextLine?.findWord(this.currentCursorX, strict);
  }
  findUpWord(strict = false): [TextWord, number] {
    return this.prevLine?.findWord(this.currentCursorX, strict);
  }

  cursorRightShift(): [TextWord, number] {
    if (this.selectionStartIndex < this.letters.length) {
      this.selectionStartIndex++;
      return [this, this.selectionStartIndex];
    }
    // -- // -- // -- //
    if (this.nextWord) {
      return [this.nextWord, 0];
    }
  }

  cursorLeftShift(): [TextWord, number] {
    if (0 < this.selectionStartIndex) {
      // this.lineIndex * this.metric.lineHeight;
      this.selectionStartIndex--;
      return [this, this.selectionStartIndex];
    }

    if (this.prev) {
      return [this.prev, this.prev.letters.length];
    }
  }

  isInMyRegion(xRef: number, strict = false): [TextWord, number] {
    let lastLast = false;
    const index = this.letters.findIndex(({ x, width }, index) => {
      if (this.index == 0 && index == 0) {
        return xRef <= x + width / 2;
      }

      if (
        this.index == this.parent.words.length - 1 &&
        index == this.letters.length - 1
      ) {
        // console.log('---------- hey ----------', x - width / 2 <= xRef);
        lastLast = true;
        return true;
      }

      return x - width / 2 <= xRef && xRef <= x + width / 2;
    });

    if (index != -1) {
      if (index == 0) {
        // console.log('index == 0');
      }

      if (index == this.letters.length - 1) {
        // console.log('index == this._letters.length - 1');
      }
      return [this, lastLast ? undefined : index];
    }
  }

  remove() {
    // -- // -- //
    this.rect?.remove();
    this.textElement?.remove();
    this.letters?.forEach(letter => letter.remove());
    this.leftRect?.remove();
    this.rightRect?.remove();
    this.cursor?.remove();
    // this.dropShadowElement?.remove();
    this.container?.destroy();
  }
}
